import { LOCALES } from "@marketplace/i18n";

export const noApplicationI18n = {
    [LOCALES.ENG]: {
        developer_welcome_banner_title: 'Welcome!',
        developer_welcome_banner_text: "This is your dashboard where you can manage your apps. Get started by adding your very first app."
    }
}